import { Link } from 'react-router-dom';

/**
 * Full-page "Access Denied" screen rendered when an authenticated user
 * navigates to a route they lack permission for.
 *
 * Uses the existing portal design system (Tailwind utility classes,
 * Material Symbols Outlined icons).
 */
export function UnauthorizedPage() {
  return (
    <div className="flex flex-col items-center justify-center h-full py-24" role="alert">
      <span className="material-symbols-outlined text-6xl text-slate-300" aria-hidden="true">
        lock
      </span>

      <h2 className="text-xl font-bold text-slate-700 mt-4">Access Denied</h2>

      <p className="text-sm text-slate-500 mt-2 text-center max-w-md">
        You don't have permission to access this page.
        Contact your administrator if you believe this is an error.
      </p>

      <Link
        to="/"
        className="mt-6 inline-flex items-center gap-1.5 rounded-lg bg-primary px-4 py-2 text-sm font-medium text-white hover:bg-primary/90 transition-colors"
      >
        <span className="material-symbols-outlined text-base" aria-hidden="true">
          arrow_back
        </span>
        Return to Dashboard
      </Link>
    </div>
  );
}
